import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { HotSpotAsset } from 'src/app/models/assets/HotSpotAsset';
import { Scene } from 'src/app/models/Scene';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-hotspot-asset-wizard',
  templateUrl: './hotspot-asset-wizard.component.html',
  styleUrls: ['./hotspot-asset-wizard.component.scss'],
})
export class HotspotAssetWizardComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;

  public steps: any = [];

  public currentStepInfo: any = {
    currentStepIndex: 0,
    currentSubStepIndex: 0,
    needHelp: false
  }


  constructor(
    public assetTypeService: AssetTypeService,    
    public modalController: ModalController,
    private alertController: AlertController,
    public validationService: ValidationService,
  ){ 
    this.steps = [{
      index: 1,
      description: "Introduction",
      complete: false,
      active: true
    }, {
      index: 2,
      description: "Actions",
      complete: false,
      active: false
    }, {
      index: 3,
      description: "Learning Objectives",
      complete: false,
      active: false
    }];
   }

  ngOnInit() {
    if (!this.editing)
    this.setUpAssetScale(this.assetInScene.sceneAssetRelation, '0.3', '0.3', '0.1');
  }

  async closeModal() {
    const alert = await this.alertController.create({
      header: 'Are you sure?',
      message: 'Are you sure you want to leave? Any changes will not be saved.',
      cssClass: 'leave-alert quizard-alert quizard-leave-alert',
      buttons: [{
        text: 'Yes',
        cssClass: '',
        handler: () => {
          this.modalController.dismiss();
        }
      }, {
        text: 'No',
        cssClass: '',
        handler: () => {
          alert.dismiss();
        }
      }
      ]
    });
    await alert.present();
  }

  validateHotspotProperties(): boolean{

    let hotspotAsset = this.assetInScene.baseAsset as HotSpotAsset;

    if (!hotspotAsset.name || hotspotAsset.name.trim().length == 0) {
      this.goToStep(0);
      return false;
    }
    return true;
  }

  saveHotspot() {

    if (this.validateHotspotProperties() == false) {
      return;
    }

    let data: any = {
      assetForScene: this.assetInScene,
      assetType: this.assetType,
    }
    this.modalController.dismiss(data);
  }

  setUpAssetScale(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xScale = x;
    sceneAssetRelation.yScale = y;
    sceneAssetRelation.zScale = z;
    sceneAssetRelation.scale = x + ' ' + y + ' ' + z;
  }

  
  exitHelp() {
    this.currentStepInfo.needHelp = false;
  }

  goToHelp() {
    this.currentStepInfo.needHelp = true;
  }

  goToStep(step: number) {
    if (this.currentStepInfo.currentStepIndex == step){
      this.currentStepInfo.needHelp = false;
      return;
    }
    this.steps[this.currentStepInfo.currentStepIndex].complete = true;
    this.currentStepInfo.currentStepIndex = step;
    this.steps[this.currentStepInfo.currentStepIndex].active = true;
    this.steps[this.currentStepInfo.currentStepIndex].complete = false;
    this.currentStepInfo.needHelp = false;
  }

  previousStep() {
      if (this.currentStepInfo.currentStepIndex > 0)
        this.goToStep(this.currentStepInfo.currentStepIndex - 1);
  }

  nextStep(){
    this.goToStep(this.currentStepInfo.currentStepIndex +1);
  }
}
